import { render, staticRenderFns } from "./AutoClickSetting.vue?vue&type=template&id=da65b2c2&scoped=true"
import script from "./AutoClickSetting.vue?vue&type=script&lang=js"
export * from "./AutoClickSetting.vue?vue&type=script&lang=js"
import style0 from "./AutoClickSetting.vue?vue&type=style&index=0&id=da65b2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da65b2c2",
  null
  
)

export default component.exports